import type { AgentList } from 'utils/agent-endpoint';
import { ProvinceAndState } from 'utils/province_or_state';

// States that must show the licensee's license number on the agent search page.
export const AGENT_LICENSE_STATES = new Set<string>([
  ProvinceAndState.ND,
]);

// Returns "{state} #{number}" when the agent's state requires a displayed license. 
export function getAgentLicense(agent: Pick<AgentList, 'state' | 'license'> | null | undefined): string {
  const state = agent?.state;
  if (!state || !AGENT_LICENSE_STATES.has(state)) {
    return '';
  }

  const licenseNumber = agent.license?.find(license => license.state === state)?.number?.trim();
  if (!licenseNumber) {
    return '';
  }

  return `${state} #${licenseNumber}`;
}
